import React from 'react';
import {observer} from "mobx-react";
import {useServices} from '../../react-hooks/use-services.hook';
import {UserMenuSeparatorBox} from '../user-menu/user-menu-items/boxes/user-menu-separator.box';
import {SpacerBox} from '../../basic-ui-components/layout/spacer.box';
import {UserMenuLogout} from '../user-menu-logout/user-menu-logout.component';
import {UserMenuAppVersionBox} from './boxes/user-menu-app-version.box';

export const UserMenuFooter: React.FC = observer(() => {
    const services = useServices();
    const translator = services.translation;

    return (<>
        <SpacerBox height={"1rem"} />
        <UserMenuAppVersionBox>
            {translator.translate("ABOUT_CLIENT_VERSION_TITLE")}
            <br />
            {services.clientDevice.clientVersion}
        </UserMenuAppVersionBox>
        
        <SpacerBox height={"1rem"} />
        <UserMenuSeparatorBox />
        <UserMenuLogout />
    </>);

});
